<template>
  <div class="tinyMCE">
    <!-- 注意：这里的 api-key 属性设置为 "no-api-key" 是为了明确禁用从 TinyMCE Cloud 加载 -->
    <editor
      v-model="myValue"
      :init="init"
      :disabled="disabled"
      api-key="no-api-key"
      @onClick="onClick"
    ></editor>
  </div>
</template>
<!-- 初始化编辑器 -->
<script>
// 引入 TinyMCE 核心和必要组件
import tinymce from "../../public/tinymce/tinymce.min.js"; // TinyMCE 核心
import Editor from "@tinymce/tinymce-vue"; // Vue 组件包装器
import "tinymce/themes/silver/theme"; // 引入默认主题（Silver主题）

// 按需引入插件 - 根据你的实际需要添加或删除
// import "tinymce/plugins/image"; // 图片插入与编辑
// import "tinymce/plugins/link"; // 超链接
// import "tinymce/plugins/table"; // 表格
// import "tinymce/plugins/lists"; // 有序、无序列表
// import "tinymce/plugins/code"; // 代码块
// import "tinymce/plugins/wordcount"; // 字数统计
// ... 其他你需要的插件

// 按需引入插件
import "tinymce/plugins/advlist";
import "tinymce/plugins/autolink";
import "tinymce/plugins/link";
import "tinymce/plugins/image";
import "tinymce/plugins/lists";
import "tinymce/plugins/charmap";
import "tinymce/plugins/preview";
import "tinymce/plugins/anchor";
import "tinymce/plugins/searchreplace";
import "tinymce/plugins/visualblocks";
import "tinymce/plugins/code";
import "tinymce/plugins/fullscreen";
import "tinymce/plugins/insertdatetime";
import "tinymce/plugins/media";
import "tinymce/plugins/table";
import "tinymce/plugins/paste";
import "tinymce/plugins/help";
import "tinymce/plugins/wordcount";

// 特别注意：必须引入默认图标，否则图标可能无法显示！
import "tinymce/icons/default";

import "tinymce/icons/default/icons";

import { getUser } from "../utils/localstore.js";
import { sevenCloud } from "../api/createCenter.js";
import * as qiniu from "qiniu-js";
async function sevenCloudAsync() {
  try {
    let res = await sevenCloud();
    if (res.code == 1) {
      return Promise.resolve(res.data);
    } else {
      return Promise.reject();
    }
  } catch (error) {
    console.log(error);
    return Promise.reject(error);
  }
}
async function QiniuAsync(row) {
  return new Promise((resolve, reject) => {
    sevenCloudAsync()
      .then((sevenToken) => {
        let key = `${row.key}/${Date.now()}/${row.file.name}`;
        const observable = qiniu.upload(row.file, key, sevenToken.token);
        let observer = {
          next(res) {},
          error(res) {
            reject(res);
          },
          complete(res) {
            let url = `${sevenToken.cdn}${res.key}`;
            resolve(url);
          },
        };
        const subscription = observable.subscribe(observer);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export default {
  components: {
    Editor,
  },
  props: {
    value: {
      // 接收外部v-model传入的值
      type: String,
      default: "",
    },
    disabled: {
      // 是否禁用编辑器
      type: Boolean,
      default: false,
    },
    // 可以根据需要接收plugins和toolbar的自定义配置
    plugins: {
      type: [String, Array],
      default: "link lists image table code wordcount",
    },
    toolbar: {
      type: [String, Array],
      default:
        "undo redo | formatselect | bold italic backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image table code | removeformat | wordcount",
    },
    placeholder: {
      type: String,
      default: "请输入",
    },
  },
  data() {
    return {
      myValue: this.value, // 内部维护的值，用于双向绑定
      init: {
        base_url: "/tinymce",
        language: "zh_CN",
        content_style: `body {
        max-height: 400px !important;overflow-y:auto !important}`,
        initOptions: { plugins: "lists link" },
        font_size_formats:
          "10px 11px 12px 13px 14px 15px 16px 17px 18px 19px 20px 21px 22px 23px 24px 25px 26px 27px 28px 29px 30px 31px 32px 33px 34px 35px 36px 37px 38px 39px 40px 44px 48px 50px 54px 60px 66px 72px 80px 88px 96px", //字体大小
        font_family_formats:
          "微软雅黑=Microsoft YaHei,Helvetica Neue,PingFang SC,sans-serif;苹果苹方=PingFang SC,Microsoft YaHei,sans-serif;宋体=simsun,serif;仿宋体=FangSong,serif;黑体=SimHei,sans-serif;Arial=arial,helvetica,sans-serif;Arial Black=arial black,avant garde;Book Antiqua=book antiqua,palatino;",
        statusbar: false, //状态栏
        menubar: false, //菜单栏
        quickbars_insert_toolbar: "anchor",
        toolbar: false, //菜单栏
        toolbar1:
          "fullscreen undo redo styles bold italic fontfamily fontsize forecolor alignjustify alignleft alignright accordion numlist bullist image media table uploadImage blockquote backcolor copy cut indent lineheight hr wordcount wordIcon paste code resourceManager link anchor", //工具栏
        // toolbar1:
        //   "fullscreen undo redo styles bold italic fontfamily fontsize forecolor alignjustify alignleft alignright accordion numlist bullist link uploadImage",
        skin: "oxide", //风格
        plugins:
          "image table fullscreen wordcount accordion autoresize lists paste media code link anchor",
        anchor_top: false,
        anchor_bottom: true,
        paste_remove_styles_if_webkit: false,
        // automatic_uploads: false,
        images_upload_handler: async (blobInfo, success, failure) =>
          new Promise((resolve, reject) => {
            QiniuAsync({
              file: blobInfo.blob(),
              name: blobInfo.filename(),
              key: "RichTextUploadImages",
            })
              .then((res) => {
                success(res);
              })
              .catch((err) => {
                reject(err);
              });
          }),
        file_picker_types: "media",
        file_picker_callback: (callback, value, meta) => {
          if (meta.filetype == "media") {
            let input = document.createElement("input"); //创建一个隐藏的input
            input.setAttribute("type", "file");
            // let that = this;
            input.onchange = function () {
              let file = this.files[0]; //选取第一个文件
              if (file.type.includes("video")) {
                QiniuAsync({
                  file,
                  key: "RichTextUploadVideo",
                  name: file.name,
                }).then((res) => {
                  callback(res, { title: file.name });
                });
              } else {
                this.$message.error("请上传视频文件");
              }
            };
            //触发点击
            input.click();
          }
        },
      },
    };
  },
  mounted() {
    // 初始化TinyMCE
    tinymce.init({});
  },
  methods: {
    onClick(e) {
      this.$emit("onClick", e, tinymce); // 抛出点击事件，可按需处理
    },
    clear() {
      // 清空编辑器内容的方法
      this.myValue = "";
    },
  },
  watch: {
    value(newValue) {
      // 监听外部传入的value变化
      this.myValue = newValue;
    },
    myValue(newValue) {
      // 监听内部myValue变化，更新v-model
      this.$emit("input", newValue);
    },
  },
};
</script>

<style scoped lang="less">
.tinymce-editor {
  width: 100%;
}
.tinyMCE {
  width: 100%;
  textarea {
    width: 100%;
  }
}
</style>
